import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
const DataTableWorkOrdersByWorkStation = ({ listWorkOrder }) => {
  const navigate = useNavigate();
  function handleTableChange({ products }) {
    return products;
  }

 
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  function operationFormatter(cell, row) {
    return (
      <>
        {row.operationDetails.operation.code}-{row.operationDetails.operation.name}
      </>
    );
  }
  function stationFormatter(cell, row) {
    return (
      <>
        {row.workstation.code}-{row.workstation.name}
      </>
    );
  }
  function bomFormatter(cell, row) {
    return (
      <>
        {row.billOfMaterials.code}-{row.product.productCode}-{row.product.name}
      </>
    );
  }
  function stateFormatter(cell, row) {
    if (row.state=== "PENDING") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          En attente
        </span>
      );
    } else if (row.state=== "STARTED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-primary">
          En cours
        </span>
      );
    } else if (row.state=== "FINISHED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-success">
          Terminé
        </span>
      );
    }
  }
  function priorityFormatter(cell, row) {
    return <>{row.priority}</>;
  }
  function creationDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.dateCreation)}</span>;
  }
  function scheduledDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.scheduledDate)}</span>;
  }
  function buttonListStepsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idWorkOrder", row.id);
          navigate(`/workOrdersSteps`);
        }}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }
  function buttonListDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idWorkOrder", row.id);
          const pdfWindow = window.open();
          pdfWindow.location.href = "/operationExecutionDetails";
        }}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }
  const columns = [
    {
      dataField: "id",
      text: "Opération",
      align: "center",
      formatter: operationFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "id",
      text: "Station de travail",
      align: "center",
      formatter: stationFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "id",
      text: "BOM",
      align: "center",
      formatter: bomFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Priorité",
      align: "center",
      headerAlign: "center",
      formatter: priorityFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "id",
      text: "Etat",
      align: "center",
      formatter: stateFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },

    {
      dataField: "id",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: creationDateFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "scheduledDate",
      text: "Date limite",
      align: "center",
      headerAlign: "center",
      formatter: scheduledDateFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Détails",
      align: "center",
      headerAlign: "center",
      formatter: buttonListDetailsFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Etapes",
      align: "center",
      headerAlign: "center",
      formatter: buttonListStepsFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];


  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les bons de travails</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="idWorkOrder"
          data={listWorkOrder}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};
export default DataTableWorkOrdersByWorkStation;
